import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import apiService from '@Task/service/documents.service';
import Vue from 'vue';
import { EventBus, DOCUMENT_EVENTS } from '@/event-bus';
import { addVersionOutcome, addVersionMessage } from '@/features/Documents/utils/documentVersions';
import { isNewVersionDraft } from '@/features/Documents/utils/documentNameConflicts';
import { resolveDocumentNameConflicts, reportVersionUploads } from '@/features/Documents/utils/nameConflictResolver';

export const  TASK_DOCUMENT = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    options: {
      sortDesc: [],
      sortBy: [],
      ItemsPerPage:50,
      search:null,
      taskId:null,
      
    },
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },

    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },

    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    CLEAR({ commit }) {
      commit('SET_ENTRIES', []);
      commit('SET_TOTAL', 0);
    },

    GET({ commit, state },taskId) {
      commit('SET_LOADING', true);
    let payLoad={
      ...state.options,
      taskId
    };

      return apiService
        .get(payLoad)
        .then((res) => {
          
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
          commit('SET_ENTRIES', []);
          commit('SET_TOTAL', 0);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_TASK_ID({ commit, state },taskId) {
      commit('SET_LOADING', true);
    let payLoad={
      ...state.options,
      taskId
    };

      return apiService
        .getByTaskId(payLoad)
        .then((res) => {
          
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
          commit('SET_ENTRIES', []);
          commit('SET_TOTAL', 0);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_ID(context, id) {
      return apiService.getById(id);
    },
    UPDATE({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_UPDATE_LOADING', true);
        apiService
          .update(data)
          .then((res) => {
            $updateOrAdd(state.entries, res.data);
           // Vue.prototype.$dialog.notify.success(`Link Successfully Updated.`);
            resolve(res);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },
    /**
     * Creates documents. Names already taken in the facility are resolved with the user first (new
     * version / keep both / skip); resolves `{ cancelled: true }` when the user cancels.
     */
    async ADD({ state, commit }, data) {
      const assetId = data?.[0]?.assetId;
      const drafts = await resolveDocumentNameConflicts(data, { assetId });
      if (drafts === null) return { cancelled: true };
      if (drafts.length === 0) return { data: [] };

      return new Promise((resolve, reject) => {

        commit('SET_UPDATE_LOADING', true);
        apiService
          .add(drafts)
          .then((res) => {
            // A file added as a new version returns the existing document: its row is updated when
            // listed, but it is not inserted, since that document need not belong to this task.
            let added = 0;
            res.data.forEach((doc, index) => {
              const listed = state.entries.some((e) => e.id == doc.id);
              if (!listed && isNewVersionDraft(drafts[index])) return;
              if (!listed) added++;
              $updateOrAdd(state.entries, doc, 'id', true);
            });
            //Vue.prototype.$dialog.notify.success(`Link  Successfully Added.`);
            commit('SET_TOTAL', state.total + added);
            reportVersionUploads(drafts, res.data, res.headers);
            resolve(res);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },
    ADD_REVISION({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        
        commit('SET_UPDATE_LOADING', true);
        apiService
          .addRevision(data)
          .then((res) => {
            $updateOrAdd(state.entries, res.data);
            const outcome = addVersionOutcome(res.headers);
            // Also warns when a pinned version stays current over the new one.
            const { type, text } = addVersionMessage(outcome, res.data);
            Vue.prototype.$dialog.notify[type](text, { position: 'top-right', timeout: 6000 });
            if (!outcome.duplicate) EventBus.$emit(DOCUMENT_EVENTS.DOCUMENT_CHANGED, res.data);
            resolve(res);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },
    
    DELETE({ state, commit }, id) {
      return apiService
        .del(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          commit('SET_TOTAL', --state.total);
          Vue.prototype.$dialog.notify.success('Deleted Successfully', {
            position: 'top-right',
            timeout: 3000,
          });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
  },
};
